/* R9 hero product carousel — adapted from GSAP's official "Infinite scrolling,
   dragging, and snapping cards" demo (codepen.io/GreenSock/pen/RwKwLWK).
   Adaptation: the original pins the page and scrubs via ScrollTrigger; that
   would fight our 4 sticky product stages, so this version AUTO-FLOWS the
   seamless loop instead (no scroll hijack) and keeps the drag + snap
   interaction. Cards scale up to full size at center, shrink at the edges. */
(function () {
  'use strict';

  var root = document.querySelector('.carousel');
  if (!root || !window.gsap) return;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) { root.classList.add('static'); return; }   // CSS grid fallback

  gsap.registerPlugin(Draggable);

  var spacing = 0.12,                                // stagger between cards
      cards = gsap.utils.toArray('.cards li'),
      snapTime = gsap.utils.snap(spacing),
      animateFunc = function (el) {
        var tl = gsap.timeline();
        tl.fromTo(el, { scale: 0, opacity: 0 },
          { scale: 1, opacity: 1, zIndex: 100, duration: 0.5, yoyo: true,
            repeat: 1, ease: 'power1.in', immediateRender: false })
          .fromTo(el, { xPercent: 400 },
            { xPercent: -400, duration: 1, ease: 'none', immediateRender: false }, 0);
        return tl;
      },
      loop = buildSeamlessLoop(cards, spacing, animateFunc),
      playhead = { offset: 0 },
      wrapTime = gsap.utils.wrap(0, loop.duration()),
      SPEED = spacing / 2.4,                         // ≈ one card every 2.4s
      dragging = false,
      resumeTimer = null;

  function render() { loop.time(wrapTime(playhead.offset)); }

  gsap.ticker.add(function (t, deltaMS) {
    if (dragging) return;
    playhead.offset += (deltaMS / 1000) * SPEED;
    render();
  });

  Draggable.create('.drag-proxy', {
    type: 'x',
    trigger: root,
    onPress: function () {
      dragging = true;
      clearTimeout(resumeTimer);
      gsap.killTweensOf(playhead);
      this.startOffset = playhead.offset;
    },
    onDrag: function () {
      playhead.offset = this.startOffset + (this.startX - this.x) * 0.0016;
      render();
    },
    onRelease: function () {
      gsap.to(playhead, {
        offset: snapTime(playhead.offset),
        duration: 0.4, ease: 'power2', onUpdate: render
      });
      resumeTimer = setTimeout(function () { dragging = false; }, 1500);
    }
  });

  // canonical GreenSock helper — triple-stacked timeline for a seamless wrap
  function buildSeamlessLoop(items, spacing, animateFunc) {
    var rawSequence = gsap.timeline({ paused: true }),
      seamlessLoop = gsap.timeline({
        paused: true,
        repeat: -1,
        onRepeat() { this._time === this._dur && (this._tTime += this._dur - 0.01); },
        onReverseComplete() { this.totalTime(this.rawTime() + this.duration() * 100); }
      }),
      cycleDuration = spacing * items.length,
      dur;
    items.concat(items).concat(items).forEach(function (item, i) {
      var anim = animateFunc(items[i % items.length]);
      rawSequence.add(anim, i * spacing);
      dur || (dur = anim.duration());
    });
    seamlessLoop.fromTo(rawSequence,
      { time: cycleDuration + dur / 2 },
      { time: '+=' + cycleDuration, duration: cycleDuration, ease: 'none' });
    return seamlessLoop;
  }
})();
